module.exports = __webpack_public_path__ + "media/images/dashboard/diamond-371964abb00e4d6e5a4ecd617253210f.svg";